import { render, staticRenderFns } from "./ModalInvoices.vue?vue&type=template&id=18a0f8a4&lang=pug&"
import script from "./ModalInvoices.vue?vue&type=script&lang=js&"
export * from "./ModalInvoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports